import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PropertiesPage } from '../properties/properties';
import { ConfigStore } from '../../stores/config.store';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

    private version: string = "";

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private config: ConfigStore) {

        this.version = config.currentVersion;
    }

    close() {
        
        // Non mostrare pi� questa pagina alla partenza
        if (this.config.data.lastVersionInfo != this.version)
        {
            this.config.data.lastVersionInfo = this.version;
            this.config.save();
        }

        // ToDo: aprire la vista di default scelta dall'utente
        this.navCtrl.setRoot(PropertiesPage, { title: 'Residenziali', category: 'R' });
    }    
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts